import React, {Component, ReactElement, ReactNode} from 'react'

import NatRoomToResidentRepo, {
    RegisterRoomToResidentImportParams,
    RegisterRoomToResidentParams,
} from '../roomToResident/repository/NatRoomToResidentRepo'
import {NatPostRoomToResident} from '../roomToResident/repository/NatPostRoomToResident'
import {NatPostRoomToResidentImport} from '../roomToResident/repository/NatPostRoomToResidentImport'
import NatRidgeRepo from '../ridge/repository/NatRidgeRepo'
import {NatGetRidge} from '../ridge/repository/NatGetRidge'
import {HAVE_OR_NOT, MESSAGE_TYPE, REGISTRATION_UNIT, ROLE_FOR_RESIDENT} from '../../../CodeMaster'
import EventEmitterExAdmin from '../../../components/shared/pageBaseComponents/EventEmitterExAdmin'
import {AdminPagePropsSet, createAdminPage} from '../../../components/shared/hoc/createAdminPage'
import {Messages} from '../../../Messages'
import {HKConstants} from '../../../HKConstants'
import {Nullable} from '../../../app/TypeHelpers'
import {StyledTableCaption, TableRowName} from '../../../styledComponents/adminPage/Table'
import PPRadioGroup, {PPRadioItemProp} from '../../../components/shared/forms/PPRadioGroup'
import PPSelect, {OptionProps} from '../../../components/shared/forms/PPSelect'
import PPTextField from '../../../components/shared/forms/PPTextField'
import {
    PageFooterArea,
    PageFotterAreaLeft,
    PageFotterAreaRight,
    PageMainArea,
} from '../../../components/shared/hoc/withAdminPageTemplate'
import {AdminPrimaryButton} from '../../../styledComponents/adminPage/Buttons'
import {BackLink} from '../../../styledComponents/adminPage/Links'
import {RequestItemErrors} from '../common/repository/NatBaseResponseInterface'
import {StyledP} from '../../../styledComponents/StyledTypeDefinitions'
import styled from 'styled-components'
import PPFileInput from '../../../components/shared/forms/PPFileInput'
import PPDatePicker from '../../../components/shared/forms/PPDatePicker'
import {formatForDateInput} from '../../../formatters/formatDate'
import {createRejectionResidentUserRegistrationApplyInfoMessage} from './NatAdminResidentUserHelper'
import {TransitionDestinationInfo} from './admin/NatTransitionDestinationInterface'
import {NatGetCondominium} from '../condominium/repository/NatGetCondominium'
import NatCondominiumRepo from '../condominium/repository/NatCondominiumRepo'
import {
    AdminLoginInfoSessionStorageKey,
    NatAdminLoginInfoSessionStorageHelper,
} from '../../common/authentication/NatAdminLoginInfoSessionStorageHelper'
import {Location} from 'react-router-dom'

import {Tab, Table, TableBody, TableCell, TableRow, Tabs} from '@mui/material';
import {SelectChangeEvent} from '@mui/material/Select'
import {autoKanaOnUpdate} from '../../common/util/Natutil'
import {formatNumberWithCommas} from '../../../formatters/formatNumberWithCommas'
import {LeftRowFlexContainer} from '../../../styledComponents/FlexComponents'

interface Props {
    condominiumRepo: NatCondominiumRepo
    RoomToResidentRepo: NatRoomToResidentRepo
    RidgeRepo: NatRidgeRepo
    eventEmitter: EventEmitterExAdmin
    location: Location
}

interface States {
    ridge: NatGetRidge
    registrationUnit: string
    selectedRidge: string
    selectedRole: string
    inputRoomNumber: string
    inputCardKeyNumber: string
    inputAdminFamilyName: string
    inputAdminFirstName: string
    inputAdminFamilyNameKana: string
    inputAdminFirstNameKana: string
    inputValidPeriodStartDate: string
    inputValidPeriodEndDate: string
    inputMemo: string
    registerButtonDisabled: boolean
    registerImportButtonDisabled: boolean
    readFile: string | ArrayBuffer | null
    importErrorMessageDisp: boolean
    importErrorMessageText: string
    selectedCondominiumCd: string
    selectedCondominiumCardKey: string
    isLoadCompleted: boolean
    convertAdminFamilyNameKana: string
    preAdminFamilyNameKana: string
    convertAdminFirstNameKana: string
    preAdminFirstNameKana: string
}

class NatAdminResidentUserRegisterPage extends Component<Props & AdminPagePropsSet, States> {
    returnLinkInfo: TransitionDestinationInfo

    constructor(props: Props & AdminPagePropsSet) {
        super(props)

        const selectedCondominiumCd = NatAdminLoginInfoSessionStorageHelper.getStringItemOrNull(
            AdminLoginInfoSessionStorageKey.SELECTED_CONDOMINIUM_CD)
        if (selectedCondominiumCd === null) {
            throw Error('クライアントセッションに物件コードが保存されていません')
        }

        this.returnLinkInfo = (this.props.location.state && this.props.location.state.returnLinkInfo)
            ? this.props.location.state.returnLinkInfo
            : {label: '居住者ユーザ検索へ戻る', url: '/admin/residentUserList'}

        this.state = {
            ridge: {
                ['details']: [],
                ['informations']: [],
                ['requestError']: null,
                ['requestItemErrors']: [],
            },
            registrationUnit: REGISTRATION_UNIT.INDIVIDUAL.value,
            selectedRidge: '',
            selectedRole: ROLE_FOR_RESIDENT.RESIDENT.value,
            inputRoomNumber: '',
            inputCardKeyNumber: '',
            inputAdminFamilyName: '',
            inputAdminFirstName: '',
            inputAdminFamilyNameKana: '',
            inputAdminFirstNameKana: '',
            inputValidPeriodStartDate: '',
            inputValidPeriodEndDate: '',
            inputMemo: '',
            registerButtonDisabled: true,
            registerImportButtonDisabled: true,
            readFile: '',
            importErrorMessageDisp: false,
            importErrorMessageText: '',
            selectedCondominiumCd: selectedCondominiumCd,
            selectedCondominiumCardKey: HAVE_OR_NOT.NOT.value,
            isLoadCompleted: false,
            convertAdminFamilyNameKana: '',
            preAdminFamilyNameKana: '',
            convertAdminFirstNameKana: '',
            preAdminFirstNameKana: '',
        }

        this.onChangeFile = this.onChangeFile.bind(this)
        this.handleRegisterCancelClick = this.handleRegisterCancelClick.bind(this)
        this.handleRegisterOkClick = this.handleRegisterOkClick.bind(this)
        this.onChangeInputRole = this.onChangeInputRole.bind(this)
        this.onChangeSelectRidge = this.onChangeSelectRidge.bind(this)
        this.onChangeInputRoomNumber = this.onChangeInputRoomNumber.bind(this)
        this.onChangeInputCardKeyNumber = this.onChangeInputCardKeyNumber.bind(this)
        this.onChangeInputAdminFamilyName = this.onChangeInputAdminFamilyName.bind(this)
        this.onChangeInputnFirstName = this.onChangeInputnFirstName.bind(this)
        this.onChangeInputFamilyNameKana = this.onChangeInputFamilyNameKana.bind(this)
        this.onChangeInputFirstNameKana = this.onChangeInputFirstNameKana.bind(this)
        this.onChangeValidPeriodStartDate = this.onChangeValidPeriodStartDate.bind(this)
        this.onChangeValidPeriodEndDate = this.onChangeValidPeriodEndDate.bind(this)
        this.onChangeInputMemo = this.onChangeInputMemo.bind(this)
        this.registerResidentUser = this.registerResidentUser.bind(this)
        this.setRegistrationUnit = this.setRegistrationUnit.bind(this)
        this.handleEmitMessage = this.handleEmitMessage.bind(this)
        this.onCompositionUpdateAdminFamilyName = this.onCompositionUpdateAdminFamilyName.bind(this)
        this.onCompositionStartAdminFamilyName = this.onCompositionStartAdminFamilyName.bind(this)
        this.onCompositionUpdateAdminFirstName = this.onCompositionUpdateAdminFirstName.bind(this)
        this.onCompositionStartAdminFirstName = this.onCompositionStartAdminFirstName.bind(this)
    }


    async componentDidMount(): Promise<void> {
        await this.props.eventEmitter.showLoading()
        try {
            // 棟取得
            const ridgesResponse: Nullable<NatGetRidge> = await this.props.asyncCallFunction(
                this.props.RidgeRepo.getRidgeList.bind(this.props.RidgeRepo, this.state.selectedCondominiumCd),
                (httpErrorOrNetworkError) => {
                    this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                },
            )
            if (ridgesResponse) {
                this.setState({ridge: ridgesResponse})
            }
            // 物件カードキー連携フラグを設定する
            const condominiumResponse: Nullable<NatGetCondominium> = await this.props.asyncCallFunction(
                this.props.condominiumRepo.getCondominium.bind(
                    this.props.condominiumRepo, this.state.selectedCondominiumCd,
                ),
                async (httpErrorOrNetworkError) => {
                    await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                },
            )
            if (condominiumResponse && condominiumResponse.details) {
                this.setState({
                    selectedCondominiumCardKey: condominiumResponse.details.cardKey,
                })
            }
        } finally {
            this.props.eventEmitter.closeLoading()
            this.setState({isLoadCompleted: true})
        }
    }

    // 登録ボタン押下
    async registerResidentUser(): Promise<void> {

        await this.props.eventEmitter.showDialog({
                title: '確認',
                errorLevel: Messages.IOPCC0001.errorLevel,
                message: Messages.IOPCC0001.toString('居住者ユーザ'),
                buttonProps: [
                    {
                        isDefault: false,
                        buttonLabel: 'キャンセル',
                        buttonHandler: this.handleRegisterCancelClick,
                    },
                    {
                        isDefault: false,
                        buttonLabel: 'OK',
                        buttonHandler: this.handleRegisterOkClick,
                    },
                ],
            },
        )
    }

    handleRegisterCancelClick(): void {
        this.props.eventEmitter.closeDialog()
    }

    async handleRegisterOkClick(): Promise<void> {
        this.props.eventEmitter.closeDialog()
        await this.props.eventEmitter.showLoading()

        try {
            if (this.state.registrationUnit === REGISTRATION_UNIT.INDIVIDUAL.value) {
                // 個別登録
                const registerParams: RegisterRoomToResidentParams = {
                    condominiumCd: this.state.selectedCondominiumCd,
                    ridgeCd: this.state.selectedRidge,
                    roomNumber: this.state.inputRoomNumber,
                    roleId: this.state.selectedRole,
                    cardKeyNumber: this.state.inputCardKeyNumber,
                    adminFamilyName: this.state.inputAdminFamilyName,
                    adminFirstName: this.state.inputAdminFirstName,
                    adminFamilyNameKana: this.state.inputAdminFamilyNameKana,
                    adminFirstNameKana: this.state.inputAdminFirstNameKana,
                    validPeriodStartDate: this.state.inputValidPeriodStartDate ?
                        formatForDateInput(this.state.inputValidPeriodStartDate) : '',
                    validPeriodEndDate: this.state.inputValidPeriodEndDate ?
                        formatForDateInput(this.state.inputValidPeriodEndDate) : '',
                    memo: this.state.inputMemo,
                }

                const postRoomToResidenResult: Nullable<NatPostRoomToResident> = await this.props.asyncCallFunction(
                    this.props.RoomToResidentRepo.postRoomToResiden.bind(this.props.RoomToResidentRepo, registerParams),
                    async (httpErrorOrNetworkError) => {
                        await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                    },
                    {defaultErrorTitle: Messages.EOPCA0001.toString('居住者ユーザ')},
                )
                if (postRoomToResidenResult &&
                    postRoomToResidenResult.details &&
                    postRoomToResidenResult.requestError === null) {
                    let detailMessage: string = Messages.IOPCC0007.toString('居住者ユーザ')
                    if (postRoomToResidenResult.details.rejectionRegistrationApplyInfoList.length) {
                        const rejectionResidentUserRegistrationApplyInfoListMessage: string =
                            createRejectionResidentUserRegistrationApplyInfoMessage(
                                postRoomToResidenResult.details.rejectionRegistrationApplyInfoList)
                        detailMessage = detailMessage + '\n' + rejectionResidentUserRegistrationApplyInfoListMessage
                    }

                    this.props.navigate(`/admin/residentUser/${postRoomToResidenResult.details.condominiumCd}/${postRoomToResidenResult.details.ridgeCd}/${postRoomToResidenResult.details.roomNumber}/${postRoomToResidenResult.details.seq}`,
                        {
                            state: {
                                initialMessage: {
                                    title: null,
                                    messageLevel: MESSAGE_TYPE.INFORMATION,
                                    detail: detailMessage,
                                },
                            },
                        },
                    )
                }

            } else {
                // 一括登録
                let fileData: string = ''
                if (this.state.readFile) {
                    const readData: string[] = String(this.state.readFile).split(',')
                    fileData = readData[1]
                }
                const registerParams: RegisterRoomToResidentImportParams = {
                    condominiumCd: this.state.selectedCondominiumCd,
                    residentUserBulkRegistrationData: fileData,
                }

                const postRoomToResidenImportResult:
                    Nullable<NatPostRoomToResidentImport> = await this.props.asyncCallFunction(
                    this.props.RoomToResidentRepo.postRoomToResidenImport.bind(
                        this.props.RoomToResidentRepo, registerParams),
                    async (httpErrorOrNetworkError) => {
                        await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                    },
                    {defaultErrorTitle: Messages.EOPCA0001.toString('居住者ユーザ')},
                )

                if (postRoomToResidenImportResult &&
                    postRoomToResidenImportResult.details &&
                    postRoomToResidenImportResult.requestItemErrors === null &&
                    postRoomToResidenImportResult.requestError === null) {
                    let detailMessage: string = Messages.IOPCC0007.toString('居住者ユーザ')
                    if (postRoomToResidenImportResult.details.rejectionRegistrationApplyInfoList.length) {
                        const rejectionResidentUserRegistrationApplyInfoListMessage: string =
                            createRejectionResidentUserRegistrationApplyInfoMessage(
                                postRoomToResidenImportResult.details.rejectionRegistrationApplyInfoList)
                        detailMessage = detailMessage + '\n' + rejectionResidentUserRegistrationApplyInfoListMessage
                    }
                    this.props.navigate(`/admin/residentUserList`,
                        {
                            state: {
                                initialMessage: {
                                    title: null,
                                    messageLevel: MESSAGE_TYPE.INFORMATION,
                                    detail: detailMessage,
                                },
                            },
                        },
                    )
                } else {
                    this.props.eventEmitter.on('invalidFile', this.handleEmitMessage)
                }
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    handleEmitMessage(itemError: RequestItemErrors): void {
        this.setState({
            registerImportButtonDisabled: true,
            importErrorMessageDisp: true,
            importErrorMessageText: itemError.message,
        })
    }


    // 登録ボタンの表示・非表示制御
    judgmentDispRegisterButton(params: {
        selectedRole: string | null,
        selectedRidge: string | null,
        inputRoomNumber: string | null,
        inputCardKeyNumber: string | null,
    }): void {

        let selectedRole: string | null
        let selectedRidge: string | null
        let inputRoomNumber: string | null
        let inputCardKeyNumber: string | null

        if (params.selectedRole !== null) {
            selectedRole = params.selectedRole
        } else {
            selectedRole = this.state.selectedRole
        }

        if (params.selectedRidge !== null) {
            selectedRidge = params.selectedRidge
        } else {
            selectedRidge = this.state.selectedRidge
        }

        if (params.inputRoomNumber !== null) {
            inputRoomNumber = params.inputRoomNumber
        } else {
            inputRoomNumber = this.state.inputRoomNumber
        }

        if (params.inputCardKeyNumber !== null) {
            inputCardKeyNumber = params.inputCardKeyNumber
        } else {
            inputCardKeyNumber = this.state.inputCardKeyNumber
        }

        if (this.state.selectedCondominiumCardKey === HAVE_OR_NOT.HAVE.value) {
            if (!selectedRole || !selectedRidge || !inputRoomNumber || !inputCardKeyNumber) {
                this.setState({registerButtonDisabled: true})
            } else {
                this.setState({registerButtonDisabled: false})
            }
        } else {
            if (!selectedRole || !selectedRidge || !inputRoomNumber) {
                this.setState({registerButtonDisabled: true})
            } else {
                this.setState({registerButtonDisabled: false})
            }
        }
    }

    onChangeInputRole(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({selectedRole: event.target.value})
        this.judgmentDispRegisterButton({
            selectedRole: event.target.value,
            selectedRidge: null,
            inputRoomNumber: null,
            inputCardKeyNumber: null,
        })

    }

    onChangeSelectRidge(event: SelectChangeEvent<unknown>): void {
        this.setState({selectedRidge: event.target.value as string})
        this.judgmentDispRegisterButton({
            selectedRole: null,
            selectedRidge: event.target.value as string,
            inputRoomNumber: null,
            inputCardKeyNumber: null,
        })
    }

    // 登録単位の切り替え
    setRegistrationUnit(event: React.ChangeEvent<{}>, newValue: string): void {
        if (newValue === REGISTRATION_UNIT.BULK.value) {
            this.setState({
                    selectedRidge: '',
                    selectedRole: ROLE_FOR_RESIDENT.RESIDENT.value,
                    inputRoomNumber: '',
                    inputCardKeyNumber: '',
                    inputAdminFamilyName: '',
                    inputAdminFirstName: '',
                    inputAdminFamilyNameKana: '',
                    inputAdminFirstNameKana: '',
                    registerButtonDisabled: true,
                },
            )
        } else {
            this.setState({
                registerImportButtonDisabled: true,
                readFile: '',
                importErrorMessageDisp: false,
                importErrorMessageText: '',
            })
        }
        this.setState({registrationUnit: newValue})
    }

    onChangeInputRoomNumber(event: React.ChangeEvent<HTMLInputElement>): void {
        const value: string = event.target.value
        this.setState({inputRoomNumber: value})
        this.judgmentDispRegisterButton({
            selectedRole: null,
            selectedRidge: null,
            inputRoomNumber: value,
            inputCardKeyNumber: null,
        })
    }

    onChangeInputCardKeyNumber(event: React.ChangeEvent<HTMLInputElement>): void {
        const value: string = event.target.value
        this.setState({inputCardKeyNumber: value})
        this.judgmentDispRegisterButton({
            selectedRole: null,
            selectedRidge: null,
            inputRoomNumber: null,
            inputCardKeyNumber: value,
        })
    }

    onCompositionStartAdminFamilyName(): void {
        this.setState({
            convertAdminFamilyNameKana: '',
            preAdminFamilyNameKana: this.state.inputAdminFamilyNameKana ?? '',
        })
    }

    onCompositionUpdateAdminFamilyName(event: React.CompositionEvent<HTMLInputElement>): void {
        autoKanaOnUpdate(event.data, (kana) => {
            this.setState({convertAdminFamilyNameKana: this.state.preAdminFamilyNameKana + kana})
        })
    }

    onCompositionStartAdminFirstName(): void {
        this.setState({
            convertAdminFirstNameKana: '',
            preAdminFirstNameKana: this.state.inputAdminFirstNameKana ?? '',
        })
    }

    onCompositionUpdateAdminFirstName(event: React.CompositionEvent<HTMLInputElement>): void {
        autoKanaOnUpdate(event.data, (kana) => {
            this.setState({convertAdminFirstNameKana: this.state.preAdminFirstNameKana + kana})
        })
    }

    onChangeInputAdminFamilyName(event: React.ChangeEvent<HTMLInputElement>): void {
        const value: string = event.target.value
        this.setState({
            inputAdminFamilyName: value,
            inputAdminFamilyNameKana: value ? this.state.convertAdminFamilyNameKana : '',
        })
    }

    onChangeInputnFirstName(event: React.ChangeEvent<HTMLInputElement>): void {
        const value: string = event.target.value
        this.setState({
            inputAdminFirstName: value,
            inputAdminFirstNameKana: value ? this.state.convertAdminFirstNameKana : '',
        })
    }

    onChangeInputFamilyNameKana(event: React.ChangeEvent<HTMLInputElement>): void {
        const value: string = event.target.value
        this.setState({inputAdminFamilyNameKana: value})
    }

    onChangeInputFirstNameKana(event: React.ChangeEvent<HTMLInputElement>): void {
        const value: string = event.target.value
        this.setState({inputAdminFirstNameKana: value})
    }

    onChangeValidPeriodStartDate(date: Nullable<Date>): void {
        if (date !== null) {
            this.setState({inputValidPeriodStartDate: date.toString()})
        } else {
            this.setState({inputValidPeriodStartDate: ''})
        }
    }

    onChangeValidPeriodEndDate(date: Nullable<Date>): void {
        if (date !== null) {
            this.setState({inputValidPeriodEndDate: date.toString()})
        } else {
            this.setState({inputValidPeriodEndDate: ''})
        }
    }

    onChangeFile(event: React.ChangeEvent<HTMLInputElement>): void {
        // ファイル情報取得
        if (event.target.files && event.target.files[0]) {
            const reader: FileReader = new FileReader()
            reader.onload = () => {
                this.setState({
                    readFile: reader.result,
                    registerImportButtonDisabled: false,
                    importErrorMessageDisp: false,
                    importErrorMessageText: '',
                })
            }
            reader.readAsDataURL(event.target.files[0])
        } else {
            this.setState({
                registerImportButtonDisabled: true,
                importErrorMessageDisp: false,
                importErrorMessageText: '',
            })
        }
    }

    onChangeInputMemo(event: React.ChangeEvent<HTMLTextAreaElement>): void {
        this.setState({inputMemo: event.target.value as string})
    }

    getRoleMasterRadioGroupData(): PPRadioItemProp[] {
        return ROLE_FOR_RESIDENT.values().map((role) => (
            {
                label: role.label,
                value: role.value,
                radioProps: {
                    autoFocus: (role.value === this.state.selectedRole),
                    onChange: this.onChangeInputRole,
                    checked: role.value === this.state.selectedRole,
                },
            }
        ))
    }

    getRidgeList(): OptionProps[] {
        let ridges: OptionProps[] = []
        if (this.state.ridge.details) {
            ridges = this.state.ridge.details.map((ridge) => {
                return ({
                    label: `${ridge.ridgeCd} : ${ridge.ridgeName}`,
                    value: `${ridge.ridgeCd}`,
                })
            })
        }

        return [{
            label: '棟を指定してください',
            value: '',
        }, ...ridges]
    }


    renderInputFormTable(): ReactNode {
        const countLimit = formatNumberWithCommas(HKConstants.VMN.RES.RESIDENCE_USER_IMPORT_CSV_LINE_COUNT_LIMIT)

        if (this.state.registrationUnit === REGISTRATION_UNIT.INDIVIDUAL.value) {
            return (
                <>
                    <Table>
                        <StyledTableCaption>居住者ユーザ情報</StyledTableCaption>
                        <TableBody>
                            <TableRow>
                                <TableRowName required>権限</TableRowName>
                                <TableCell colSpan={4}>
                                    <PPRadioGroup
                                        row
                                        data={this.getRoleMasterRadioGroupData()}
                                        eventKeys={['roleId']}
                                        eventEmitter={this.props.eventEmitter}
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableRowName required>棟名</TableRowName>
                                <TableCell colSpan={4}>
                                    <PPSelect
                                        eventEmitter={this.props.eventEmitter}
                                        data={this.getRidgeList()}
                                        onChange={this.onChangeSelectRidge}
                                        value={this.state.selectedRidge}
                                        eventKeys={['ridgeCd']}
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableRowName required>部屋番号</TableRowName>
                                <TableCell colSpan=
                                               {this.state.selectedCondominiumCardKey ===
                                               HAVE_OR_NOT.HAVE.value ? 2 : 4}>
                                    <PPTextField
                                        InputProps={{
                                            inputProps: {
                                                maxLength: 4,
                                            },
                                        }}
                                        required
                                        fullWidth
                                        onChange={this.onChangeInputRoomNumber}
                                        eventKeys={['roomNumber']}
                                        eventEmitter={this.props.eventEmitter}
                                    />
                                </TableCell>
                                {this.state.selectedCondominiumCardKey === HAVE_OR_NOT.HAVE.value &&
                                    <>
                                        <TableRowName required>カードキー番号</TableRowName>
                                        <TableCell colSpan={2}>
                                            <PPTextField
                                                InputProps={{
                                                    inputProps: {
                                                        maxLength: 10,
                                                    },
                                                }}
                                                required
                                                fullWidth
                                                onChange={this.onChangeInputCardKeyNumber}
                                                eventKeys={['cardKeyNumber']}
                                                eventEmitter={this.props.eventEmitter}
                                            />
                                        </TableCell>
                                    </>
                                }
                            </TableRow>
                            <TableRow>
                                <TableRowName>管理者確認用氏名</TableRowName>
                                <TableCell colSpan={2}>
                                    姓
                                    <PPTextField
                                        InputProps={{
                                            inputProps: {
                                                name: 'adminFamilyName',
                                                id: 'adminFamilyName',
                                                maxLength: 10,
                                            },
                                        }}
                                        required
                                        fullWidth
                                        value={this.state.inputAdminFamilyName}
                                        onInput={this.onChangeInputAdminFamilyName}
                                        onChange={this.onChangeInputAdminFamilyName}
                                        onCompositionStart={this.onCompositionStartAdminFamilyName}
                                        onCompositionUpdate={this.onCompositionUpdateAdminFamilyName}
                                        eventKeys={['adminFamilyName']}
                                        eventEmitter={this.props.eventEmitter}
                                    />
                                </TableCell>
                                <TableCell colSpan={2}>
                                    名
                                    <PPTextField
                                        InputProps={{
                                            inputProps: {
                                                name: 'adminFirstName',
                                                id: 'adminFirstName',
                                                maxLength: 10,
                                            },
                                        }}
                                        required
                                        fullWidth
                                        value={this.state.inputAdminFirstName}
                                        onInput={this.onChangeInputnFirstName}
                                        onChange={this.onChangeInputnFirstName}
                                        onCompositionStart={this.onCompositionStartAdminFirstName}
                                        onCompositionUpdate={this.onCompositionUpdateAdminFirstName}
                                        eventKeys={['adminFirstName']}
                                        eventEmitter={this.props.eventEmitter}
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableRowName>管理者確認用氏名(フリガナ)</TableRowName>
                                <TableCell colSpan={2}>
                                    セイ
                                    <PPTextField
                                        InputProps={{
                                            inputProps: {
                                                name: 'adminFamilyNameKana',
                                                id: 'adminFamilyNameKana',
                                                maxLength: 20,
                                            },
                                        }}
                                        required
                                        fullWidth
                                        value={this.state.inputAdminFamilyNameKana}
                                        onInput={this.onChangeInputFamilyNameKana}
                                        onChange={this.onChangeInputFamilyNameKana}
                                        eventKeys={['adminFamilyNameKana']}
                                        eventEmitter={this.props.eventEmitter}
                                    />
                                </TableCell>
                                <TableCell colSpan={2}>
                                    メイ
                                    <PPTextField
                                        InputProps={{
                                            inputProps: {
                                                name: 'adminFirstNameKana',
                                                id: 'adminFirstNameKana',
                                                maxLength: 20,
                                            },
                                        }}
                                        required
                                        fullWidth
                                        value={this.state.inputAdminFirstNameKana}
                                        onInput={this.onChangeInputFirstNameKana}
                                        onChange={this.onChangeInputFirstNameKana}
                                        eventKeys={['adminFirstNameKana']}
                                        eventEmitter={this.props.eventEmitter}
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableRowName>有効期間開始日</TableRowName>
                                <TableCell colSpan={2} style={{paddingBottom: 18, paddingTop: 21.5}}>
                                    <PPDatePicker
                                        onChangeDate={this.onChangeValidPeriodStartDate}
                                        value={(this.state.inputValidPeriodStartDate) ?
                                            new Date(this.state.inputValidPeriodStartDate) : null}
                                        eventEmitter={this.props.eventEmitter}
                                        eventKeys={['validPeriodStartDate']}
                                    />
                                </TableCell>
                                <TableRowName>有効期間終了日</TableRowName>
                                <TableCell colSpan={2} style={{paddingBottom: 18, paddingTop: 21.5}}>
                                    <PPDatePicker
                                        onChangeDate={this.onChangeValidPeriodEndDate}
                                        value={(this.state.inputValidPeriodEndDate) ?
                                            new Date(this.state.inputValidPeriodEndDate) : null}
                                        eventEmitter={this.props.eventEmitter}
                                        eventKeys={['validPeriodEndDate']}
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableRowName>メモ</TableRowName>
                                <TableCell colSpan={4}>
                                    <PPTextField
                                        InputProps={{
                                            inputProps: {
                                                maxLength: 2000,
                                                minRows: 3,
                                            },
                                        }}
                                        required
                                        fullWidth
                                        multiline
                                        value={this.state.inputMemo}
                                        onChange={this.onChangeInputMemo}
                                        eventKeys={['memo']}
                                        eventEmitter={this.props.eventEmitter}
                                    />
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </>
            )
        } else {
            return (
                <>
                    <Table>
                        <StyledTableCaption>居住者ユーザ情報</StyledTableCaption>
                        <TableBody>
                            <TableRow>
                                <TableRowName required>居住者ユーザ一括登録CSV</TableRowName>
                                <TableCell>
                                    <FileInputArea>
                                        <PPFileInput
                                            InputProps={{
                                                inputProps: {
                                                    id: 'residentUserCsv',
                                                    name: 'residentUserCsv',
                                                },
                                            }}
                                            fullWidth={false}
                                            onChange={this.onChangeFile}
                                            eventKeys={['residentUserBulkRegistrationData']}
                                            eventEmitter={this.props.eventEmitter}
                                        />
                                        1ファイル5MB、 データ件数{countLimit}件まで
                                    </FileInputArea>
                                </TableCell>
                            </TableRow>
                            {(this.state.importErrorMessageDisp) ?
                                <TableRow>
                                    <TableRowName>エラー内容</TableRowName>
                                    <TableCell>
                                        <PPTextField
                                            InputProps={{
                                                inputProps: {
                                                    readOnly: true,
                                                    minRows: 5,
                                                    maxRows: 5,
                                                },
                                            }}
                                            fullWidth
                                            multiline
                                            value={this.state.importErrorMessageText}
                                        />
                                    </TableCell>
                                </TableRow> : <></>
                            }
                        </TableBody>
                    </Table>
                </>
            )
        }
    }


    renderPageFooterArea(): ReactNode {
        return (
            <>
                <PageFotterAreaRight>
                    <AdminPrimaryButton
                        disabled={this.state.registrationUnit === REGISTRATION_UNIT.INDIVIDUAL.value ?
                            this.state.registerButtonDisabled : this.state.registerImportButtonDisabled}
                        onClick={this.registerResidentUser}
                    >
                        登録する
                    </AdminPrimaryButton>
                </PageFotterAreaRight>
                <PageFotterAreaLeft>
                    <BackLink onClick={() => this.props.navigate(this.returnLinkInfo.url)}>
                        {this.returnLinkInfo.label}
                    </BackLink>
                </PageFotterAreaLeft>
            </>
        )
    }


    renderRegistrationUnitTable(): ReactNode {
        return (
            <>

                <Tabs
                    value={this.state.registrationUnit}
                    onChange={this.setRegistrationUnit}
                    aria-label="simple tabs example"
                    indicatorColor="primary"
                    textColor="primary"
                >
                    <Tab
                        label={REGISTRATION_UNIT.INDIVIDUAL.label}
                        value={REGISTRATION_UNIT.INDIVIDUAL.value}
                        style={{minWidth: '157px'}}
                    />
                    <Tab
                        label={REGISTRATION_UNIT.BULK.label}
                        value={REGISTRATION_UNIT.BULK.value}
                        style={{minWidth: '157px'}}
                    />
                    <TabLabel>次の項目を入力してください。</TabLabel>
                </Tabs>

            </>
        )
    }

    render(): ReactElement {
        if (!this.state.isLoadCompleted) {
            return (<></>)
        }
        return (
            <>
                <PageMainArea>
                    {this.renderRegistrationUnitTable()}
                    <form>
                        {this.renderInputFormTable()}
                    </form>
                </PageMainArea>
                <PageFooterArea>
                    {this.renderPageFooterArea()}
                </PageFooterArea>
            </>
        )
    }
}

export default createAdminPage(NatAdminResidentUserRegisterPage)

const TabLabel: StyledP = styled.p`
  display: inline-flex;
  flexDirection: column;
  justifyContent: center;
`

const FileInputArea = styled(LeftRowFlexContainer)`
  gap: 16px;
`
